module.exports = __webpack_public_path__ + "bdc112fdc65be6d618620536408eee5f.woff";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Light.woff
// module id = 640
// module chunks = 0